import PropTypes from 'prop-types';

import { Helmet } from 'react-helmet';

const SEO = ({ title, description, ogTitle, ogDescription, ogImage, person, noindex = false }) => {
  const canonical =
    typeof window !== 'undefined' ? window.location.href.split('#')[0] : null;

  const resolvedOgTitle = ogTitle || title;
  const resolvedOgDescription = ogDescription || description;
  const resolvedOgImage = ogImage || person?.image || undefined;
  const siteUrl = person?.url || (canonical ? new URL(canonical).origin : undefined);

  const personJsonLd = person
    ? {
        '@context': 'https://schema.org',
        '@type': 'Person',
        ...(person['@id'] ? { '@id': person['@id'] } : {}),
        name: person.name,
        url: person.url || canonical || undefined,
        image: person.image,
        jobTitle: person.jobTitle,
        description: person.description,
        sameAs: person.sameAs,
        knowsAbout: person.knowsAbout,
      }
    : null;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="robots" content={noindex ? "noindex, nofollow" : "index, follow"} />

      {description ? <meta name="description" content={description} /> : null}

      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:title" content={resolvedOgTitle} />
      {resolvedOgDescription ? (
        <meta property="og:description" content={resolvedOgDescription} />
      ) : null}
      {canonical ? <meta property="og:url" content={canonical} /> : null}
      {resolvedOgImage ? <meta property="og:image" content={resolvedOgImage} /> : null}
      {siteUrl ? <meta property="og:site_name" content="Regina Nigma" /> : null}

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={resolvedOgTitle} />
      {resolvedOgDescription ? (
        <meta name="twitter:description" content={resolvedOgDescription} />
      ) : null}
      {resolvedOgImage ? <meta name="twitter:image" content={resolvedOgImage} /> : null}

      {canonical ? <link rel="canonical" href={canonical} /> : null}

      {personJsonLd ? (
        <script type="application/ld+json">
          {JSON.stringify(personJsonLd)}
        </script>
      ) : null}
    </Helmet>
  );
};
SEO.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  ogTitle: PropTypes.string,
  ogDescription: PropTypes.string,
  ogImage: PropTypes.string,
  person: PropTypes.shape({
    name: PropTypes.string,
    url: PropTypes.string,
    image: PropTypes.string,
    jobTitle: PropTypes.string,
    description: PropTypes.string,
    sameAs: PropTypes.arrayOf(PropTypes.string),
    knowsAbout: PropTypes.arrayOf(PropTypes.string),
  }),
  noindex: PropTypes.bool,
};

export default SEO;
